import styled from 'styled-components';

import { Typography } from '../../../display/Typography';
import { MainButton } from '../../../inputs/buttons/MainButton';
import InputText from '../../../inputs/InputText';
import {
  TableContainer,
  Td,
} from '../../../display/tables/summaryTables/SummaryTablesStyles';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 70vh;
`;

export const ScrollableContent = styled.div`
  /* Sin overflow: la lista abierta del desplegable es absoluta y, con
     scroll, al cerrarse el contenido salta y el clic en «Añadir» se pierde.
     La lista de personas ya hace scroll por su cuenta. */
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const Row = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1rem;

  > :first-child {
    flex: 1;
  }
`;

/** Fila del desplegable: el botón se queda arriba aunque la lista abierta crezca. */
export const AddRow = styled(Row)`
  align-items: flex-start;
`;

export const StyledInputText = styled(InputText)`
  > p {
    margin-top: 0.5rem;
  }
`;

export const SectionTitle = styled(Typography)`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.black};
`;

/**
 * Las personas del grupo en la tabla de siempre de la app (feedback 2-nov:
 * la caja con botones de texto quedaba plana y no se parecía a nada). Cabecera
 * gris fija, filas con su raya y la papelera de las tablas de Gestión.
 * La altura es relativa a la pantalla: en una baja el pie sigue a la vista.
 */
export const MembersTableContainer = styled(TableContainer)`
  height: auto;
  /* 24vh: a 1024×600 caben dos filas enteras y el pie sigue a la vista. */
  max-height: min(22rem, 24vh);
  border-radius: ${({ theme }) => theme.borderRadius.md};
`;

/** El correo se corta con «…» en vez de ensanchar la ventana (entero en el `title`). */
export const EmailTd = styled(Td)`
  max-width: 24rem;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.greyDark};
`;

export const InactiveTag = styled.span`
  margin-left: ${({ theme }) => theme.spacing.xs};
  padding: 0.1rem 0.8rem;
  border-radius: 100rem;
  font-size: ${({ theme }) => theme.fontSize.XS};
  background-color: ${({ theme }) => theme.colors.greyLight};
  color: ${({ theme }) => theme.colors.black};
`;

export const EmptyMessage = styled(Typography)`
  color: ${({ theme }) => theme.colors.greyDark};
  padding: ${({ theme }) => theme.spacing.xs} 0;
`;

export const OtherGroupList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: min(8rem, 7vh);
  overflow-y: auto;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.greyDark};
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.5rem 0 0.5rem;
`;

export const ActionButton = styled(MainButton)`
  min-width: 10rem;
`;
